import theme          from 'antd/lib/theme';
import useThemeMode   from '@widesk-ui/hooks/useThemeMode';
import { NAV_BG }     from '@/theme';

export type DesignTokens = ReturnType<typeof useDesignTokens>;

export default function useDesignTokens() {
	const { token } = theme.useToken();
	const { mode }  = useThemeMode();

	return {
		// Design system ant design
		surface: {
			page    : token.colorBgLayout,       // fond général de la page
			card    : token.colorBgContainer,    // carte, panneau, formulaire
			elevated: token.colorBgElevated,     // modale, popover, menu déroulant
			subtle  : token.colorFillQuaternary, // zone légèrement teintée, hover
			disabled: token.colorBgContainerDisabled,
		},

		// Couleurs de texte
		text: {
			default  : token.colorText,
			secondary: token.colorTextSecondary,
			muted    : token.colorTextDescription,
			disabled : token.colorTextDisabled,
		},

		// Bordures
		border: {
			default: token.colorBorder,
			subtle : token.colorBorderSecondary,
		},

		// Remplissages (zones légèrement colorées)
		fill: {
			default  : token.colorFill,
			secondary: token.colorFillSecondary,
			tertiary : token.colorFillTertiary,
			subtle   : token.colorFillQuaternary,
		},

		// Ombres
		shadow: {
			card    : token.boxShadow,
			elevated: token.boxShadowSecondary,
		},

		// Couleurs sémantiques
		color: {
			primary: token.colorPrimary,
			success: token.colorSuccess,
			error  : token.colorError,
			warning: token.colorWarning,
		},

		// Couleurs de navigation (header, sidebar) — définies dans src/theme
		nav: {
			bg: NAV_BG[mode],
		},
	};
}
